import axios from 'axios'

const request = axios.create({
    // baseURL: "http://192.168.1.195:8102",
    baseURL: "https://shop.byszdd.com",
    timeout: 50000,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        // 'Content-Type': 'application/x-www-form-urlencoded',
    }
})

request.interceptors.request.use(config => {
    return config
}, error => {
    console.log(error)
    return Promise.reject(error)
})

request.interceptors.response.use(response => {
    return response.data
}, error => {
    console.log(error)
    return Promise.reject(error)
})


export default {
    post(url, data) {
        return request({
            method: 'post',
            url,
            data,
        })
    },
    get(url, params, headers = {}) {
        return request({
            method: 'get',
            url,
            params,
            headers
        })
    },
    put(url, data) {
        return request({
            method: 'put',
            url,
            data
        })
    },
    delete(url, data) {
        return request({
            method: 'delete',
            url,
            data
        })
    }
}